import $ from 'jquery';
/**
 * Enables the "about" page functionality.
 */
const enableAboutFunctionality = () => {
    if ($('#about').length === 0) {
        return;
    }
    $('.team-member .card').each(function () {
        const $card = $(this);
        $card.on('click', () => {
            $('.card-body', $card).toggleClass('open');
        });
    });
};
export default enableAboutFunctionality;
